import dayjs from 'dayjs';

import { useConversationUsage } from 'hooks/use-conversation-usage';

import { formatDate } from 'helpers/dates-formatter';
import { clamp } from 'helpers/number.helpers';

const FULL_PERCENT = 100;
const MIN_PERCENT = 0;
const MAX_PERCENT = 100;
const RESET_DATE_FORMAT = 'MMM D, YYYY';

export interface UseTokenUsageResult {
  percentRemaining: number;
  resetDate: string;
  hasUsageData: boolean;
  isLimitReached: boolean;
  isResetDateInFuture: boolean;
  isError: boolean;
  isLoading: boolean;
}

interface UseTokenUsageOptions {
  oktaUserId: string;
  enabled?: boolean;
}

export const useTokenUsage = ({
  oktaUserId,
  enabled = true,
}: UseTokenUsageOptions): UseTokenUsageResult => {
  const query = useConversationUsage({ oktaUserId, enabled });
  const { data, isSuccess, isError, isLoading } = query;

  const percentRemaining = clamp(
    FULL_PERCENT - (data?.percentUsed ?? 0),
    MIN_PERCENT,
    MAX_PERCENT
  );
  const resetDate = formatDate(data?.periodEnd, RESET_DATE_FORMAT) ?? '';
  const hasUsageData = isSuccess && data != null;

  const isResetDateInFuture = data?.periodEnd
    ? dayjs(data.periodEnd).isAfter(dayjs(), 'day')
    : false;

  return {
    percentRemaining,
    resetDate,
    hasUsageData,
    isLimitReached: hasUsageData && percentRemaining === MIN_PERCENT,
    isResetDateInFuture,
    isError,
    isLoading,
  };
};
